<template>
  <div class="container" @click="goToDetail()">
    <a-spin v-if="loading" style="position: absolute; top: 43%; left: 50%; transform: translate(0, -50%);"/>
    <div class="header">
      <a class="title" @click.stop="goToDetail()">
        {{ service.name }}
      </a>
      <span class="more-btn" @click.stop>
        <a-dropdown>
          <a-icon type="ellipsis" class="ellipsis-icon" />
          <a-menu slot="overlay">
            <a-menu-item>
              <edit-button v-permission="{ action: 'service.service.update', effect: 'disabled' }"
                @click="$refs.inputDrawer.show(service.id)"></edit-button>
            </a-menu-item>
            <a-menu-item>
              <delete-button v-permission="{ action: 'service.service.delete', effect: 'disabled' }"
                @confirm="confirm"></delete-button>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </div>

    <div :class="messageStatus.class">
      <div class="message-icon-container">
        <message-icon :icon="messageStatus.icon" class="message-icon"></message-icon>
      </div>
      <div class="message-content">
        <!-- 应用异常 -->
        <template v-if="safeDetailData.abnormalApplicationCount">
          有
          <span class="highlight-danger">
            {{ safeDetailData.abnormalApplicationCount }}
          </span>
          个应用有异常
        </template>

        <!-- 严重告警 -->
        <template v-else-if="safeDetailData.serviceAlert.disaster + safeDetailData.serviceAlert.high">
          <div>应用无异常，</div>
          <div>
            有
            <span class="highlight-warning">
              {{ safeDetailData.serviceAlert.disaster + safeDetailData.serviceAlert.high }}
            </span>
            条 严重、紧急级别的告警
          </div>
        </template>

        <!-- 计划告警 -->
        <template v-else-if="safeDetailData.serviceAlert.average + safeDetailData.serviceAlert.warning">
          <div>应用无异常，</div>
          <div>
            有
            <span class="highlight-info">
              {{ safeDetailData.serviceAlert.average + safeDetailData.serviceAlert.warning }}
            </span>
            条 普通、预警级别的告警
          </div>
        </template>
        <template v-else>无告警，应用无异常</template>
      </div>
    </div>

    <div class="split split-bottom-12"></div>

    <div class="module-header-fs14">繁忙度</div>
    <a-row class="busyness-row">
      <a-col :span="8" v-for="item in busynessDetail" :key="item.key">
        <div @click.stop="goBusynessDetail(item.key)">
          <a-statistic
            class="busyStatistic"
            :title="item.name"
            :value="item.value"
            :value-style="getStatisticValueStyle(item.color)"
          >
          </a-statistic>
        </div>
      </a-col>
    </a-row>

    <div class="module-header-fs14">健康度</div>
    <div class="healthContainer" @click.stop="goHealthDetail">
      <template v-if="healthDetail.length">
        <div
          v-for="item in healthDetail" :key="item.id"
          :class="{
            'tag': true,
            'health_3': item.score < 60,
            'health_1': item.score >= 80,
            'health_2': item.score >= 60 && item.score < 80
          }"
        >
          <span class="tag-name">{{ item.name }}</span>
          <span class="tag-score">{{ item.score }}分</span>
        </div>
      </template>

      <template v-else>
        <div class="tag health-empty">
          <span class="tag-name">暂无数据</span>
        </div>
      </template>
    </div>

    <div class="split split-margin-12"></div>

    <div class="bottom">
      <div class="project-manager">
        <a-tooltip :title="`系统管理员：${service.project_manager || '-'}`">
          <a-icon type="user" />
          <span class="manager-name">{{ service.project_manager || '-' }}</span>
        </a-tooltip>
      </div>
      <div class="service-tags">
        <a-space :size="0">
          <a-tag v-if="service.status" :color="statusColor[service.status] || ''">{{ $t(`service_status.${service.status}`) }}</a-tag>
          <a-tag v-if="service.level" :color="levelColor[service.level] || levelColor.default">{{ $t(`service_level.${service.level}`) }}</a-tag>
        </a-space>
      </div>
  </div>

    <input-drawer ref="inputDrawer" @ok="$emit('ok')"></input-drawer>
  </div>
</template>

<script>
import {
  deleteService
} from '@/api/service'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'
import InputDrawer from './InputDrawer'
import MessageIcon from './MessageIcon'

export default {
  name: 'ServiceCard',
  components: {
    DeleteButton,
    EditButton,
    InputDrawer,
    MessageIcon
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    detailData: {
      type: Object,
      default: () => ({
        abnormalApplicationCount: 0,
        serviceAlert: {
          disaster: 0,
          high: 0,
          average: 0,
          warning: 0
        },
        busynessDetail: [
          {
            name: '正常',
            key: 'normal',
            value: 0,
            color: '#51a8f2'
          },
          {
            name: '繁忙',
            key: 'busy',
            value: 0,
            color: '#fa8c16'
          },
          {
            name: '空闲',
            key: 'idle',
            value: 0,
            color: '#43b94d'
          }
        ],
        healthDetail: []
      })
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      statusColor: {
        built: 'blue',
        building: 'cyan'
      },
      levelColor: {
        2: '#ffbc75',
        3: '#ffab53',
        4: '#ff9a30',
        5: '#ff890e',
        default: '#ffcc98'
      }
    }
  },
  computed: {
    safeDetailData () {
      return {
        abnormalApplicationCount: 0,
        serviceAlert: {
          disaster: 0,
          high: 0,
          average: 0,
          warning: 0
        },
        busynessDetail: [
          { name: '正常', key: 'normal', value: 0, color: '#51a8f2' },
          { name: '繁忙', key: 'busy', value: 0, color: '#fa8c16' },
          { name: '空闲', key: 'idle', value: 0, color: '#43b94d' }
        ],
        healthDetail: [],
        ...this.detailData
      }
    },
    messageStatus () {
      const { abnormalApplicationCount, serviceAlert } = this.safeDetailData
      if (abnormalApplicationCount) {
        return {
          icon: 'urgent',
          class: 'message-container message-container-urgent'
        }
      }
      const criticalAlerts = serviceAlert.disaster + serviceAlert.high
      const normalAlerts = serviceAlert.average + serviceAlert.warning
      if (criticalAlerts) {
        return {
          icon: 'important',
          class: 'message-container message-container-important'
        }
      }
      if (normalAlerts) {
        return {
          icon: 'attention',
          class: 'message-container message-container-attention'
        }
      }
      return {
        icon: 'healthy',
        class: 'message-container message-container-healthy'
      }
    },
    busynessDetail () {
      return this.safeDetailData.busynessDetail || [
        { name: '正常', key: 'normal', value: 0, color: '#51a8f2' },
        { name: '繁忙', key: 'busy', value: 0, color: '#fa8c16' },
        { name: '空闲', key: 'idle', value: 0, color: '#43b94d' }
      ]
    },
    healthDetail () {
      return this.safeDetailData.healthDetail || []
    }
  },
  methods: {
    getStatisticValueStyle (color) {
      return {
        fontSize: '18px',
        fontWeight: 500,
        color: color
      }
    },
    goToDetail () {
      this.$router.push({
        name: 'ServiceDashboardDetail',
        params: {
          id: this.service.id
        }
      })
    },
    goBusynessDetail (type) {
      this.$router.push({
        name: 'ServiceDashboardDetail',
        params: {
          id: this.service.id,
          active_tab: 'busyness',
          busyness_type: type
        }
      })
    },
    goHealthDetail () {
      this.$router.push({
        name: 'ServiceDashboardDetail',
        params: {
          id: this.service.id,
          active_tab: 'health'
        }
      })
    },
    async confirm () {
      try {
        const res = await deleteService(this.service.id)
        this.$message.success(res.message)
        this.$emit('ok')
      } catch (error) {
        console.error(`Failed to delete service ${this.service.id}:`, error)
        this.$message.error('删除失败，请重试')
      }
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 13px 16px;
  cursor: pointer;
}

.header {
  height: 48px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 48px;
  box-sizing: border-box;
}

.more-btn {
  float: right;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.25);
  z-index: 9999;
}

.ellipsis-icon {
  cursor: pointer;
}

.message-container {
  height: 72px;
  margin: 14px 5px 14px 5px;
  position: relative;
  padding: 12px 18px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.message-container::after {
  content: '';
  width: 100%;
  height: 72px;
  border-radius: 8px;
  opacity: 0.09;
  position: absolute;
  top: 0;
  left: 0;
}

.message-container-urgent {
  color: #ff4d4f;
}

.message-container-urgent::after {
  background: #ff4d4f;
}

.message-container-important {
  color: #faad14;
}

.message-container-important::after {
  background: #faad14;
}

.message-container-attention {
  color: #096dd9;
}

.message-container-attention::after {
  background: #096dd9;
}

.message-container-healthy {
  color: #52c41a;
}

.message-container-healthy::after {
  background: #52c41a;
}

.message-icon-container {
  height: 36px;
  margin-right: 32px;
  font-size: 36px;
}

.message-icon {
  vertical-align: 4px;
}

.message-content {
  line-height: 20px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.highlight-danger {
  color: #ff4d4f;
  font-size: 16px;
}

.highlight-warning {
  color: #faad14;
  font-size: 16px;
}

.highlight-info {
  color: #096dd9;
  font-size: 16px;
}

.split {
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  opacity: 0.5;
}

.split-bottom-12 {
  margin-bottom: 12px;
}

.split-margin-12 {
  margin: 12px 0;
}

.module-header-fs14 {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

.busyness-row {
  text-align: center;
  margin: 6px 0 12px 0;
}

.busyStatistic :deep(.ant-statistic-title) {
  font-size: 13px;
  margin-bottom: 0;
  color: rgba(0, 0, 0, 0.75);
  z-index: 9999;
}

.healthContainer {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  margin: 6px 2px 0 2px;
  min-height: 64px;
  z-index: 9999;
}

.healthContainer .tag {
  padding: 0 6px;
  height: 26px;
  border-radius: 4px;
  margin: 2px 4px;
  text-align: center;
  line-height: 26px;
}

.tag-name {
  color: rgba(0, 0, 0, 0.55);
  font-size: 12px;
}

.tag-score {
  margin-left: 2px;
  font-size: 12px;
  font-weight: 500;
}

.health_1 {
  color: #43B94D;
  background: #e9ffdd;
}

.health_2 {
  color: #faa614;
  background: #fff8de;
}

.health_3 {
  color: #ff4d4f;
  background: #ffe5e4;
}

.health-empty {
  color: rgba(0, 0, 0, 0.45);
  background: #f5f5f5;
}

.bottom {
  display: flex;
  align-items: center;
  height: 24px;
  overflow: hidden;
}

.project-manager {
  flex: 1;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.85);
}

.manager-name {
  margin-left: 4px;
}

.service-tags {
  width: 110px;
  text-align: right;
}
</style>
